import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const UserEditDialogControls = (props) => {
  const { onSave, onClose, disabled } = props;
  return (
    <div>
      <div className="mt4">
        <Button
          variant="contained"
          id="UserEditDialogControls-saveButton"
          onClick={onSave}
          disabled={disabled}
          color="primary"
        >
          <FormattedMessage id="save" />
        </Button>
        <Button
          variant="contained"
          className="fr"
          onClick={onClose}
          color="secondary"
        >
          <FormattedMessage id="genericClose" />
        </Button>
      </div>
    </div>
  );
};

UserEditDialogControls.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default UserEditDialogControls;
